import { render, staticRenderFns } from "./pdf-generator.vue?vue&type=template&id=45c647f3"
import script from "./pdf-generator.ts?vue&type=script&lang=ts&external"
export * from "./pdf-generator.ts?vue&type=script&lang=ts&external"
import style0 from "./pdf-generator.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports